import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";

export default function BlogList() {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);

  return (
    <div className="max-w-5xl mx-auto" data-testid="blog-list">
      <div className="flex items-center gap-2 mb-6">
        <Newspaper className="w-6 h-6 text-[#C85A32]" />
        <h1 className="font-display text-3xl font-extrabold text-[#0F172A]">Le Blog TOGOBATI</h1>
      </div>
      {!posts ? <p className="text-slate-400">Chargement…</p>
        : posts.length === 0 ? <p className="text-slate-400">Aucun article pour le moment.</p>
        : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {posts.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl border border-slate-200 overflow-hidden hover:shadow-lg transition" data-testid={`blog-post-${p.slug}`}>
                {p.image && <img src={p.image} alt={p.title} className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500" />}
                <div className="p-4">
                  <p className="text-xs text-slate-400">{formatDate(p.created_at)}</p>
                  <h2 className="font-display text-lg font-bold text-[#0F172A] mt-1 group-hover:text-[#C85A32] transition">{p.title}</h2>
                  <p className="text-sm text-slate-500 mt-1 line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
    </div>
  );
}
